/** @jsxImportSource @emotion/react */
import React, { useCallback } from 'react';
import { jsx, css } from '@emotion/react';
import { useNavigate, useParams } from 'react-router';
import { queryCache, useMutation, useQuery } from 'react-query';
import EmailComposer from './components/EmailComposer';
import api from '../../libs/api';
import { Sale, SaleEmail } from './types';
import { FormattedMessage } from 'components/i18n';
import { useNotifications } from '../../components/notification';

type Props = {
}
export const fetchEmailProposal = async (key: string, id: string,) => api.get(`/Sales/${id}/email-proposal`);
const sendEmail = async (variables: SaleEmail & {saleId: string}) => {
  const {saleId, ...email} = variables;
  return api.post(`/Sales/${saleId}/email`, email);
}

const SendEmailPage: React.FC<Props> = (props) => {
  const { showSuccessNotification, showErrorNotification } = useNotifications();
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: emailProposal, error, isLoading } = useQuery(['emailProposal',id], fetchEmailProposal);
  const [send, { status, isLoading: isSending }] = useMutation(sendEmail, {
    onSuccess: () => {
      queryCache.invalidateQueries(['sale', id]);
      showSuccessNotification(
        <FormattedMessage
          id="sale.SaleEmailPage.notifications.save.success.title`"
          defaultMessage="Email send"
        />);
        navigate(`../`);
    },
    onError: (e: any) => {
      showErrorNotification(
        e.message
      )}
  });
  const handleSubmit = useCallback((values) => {
    console.log('values',values);
    send({...values, saleId: id});
  },[id]);

  const handleCancel = useCallback(() => {
    navigate('../.')
  },[]);

  return (<EmailComposer initialValues={emailProposal} onSubmit={handleSubmit} isSending={isSending} onCancel={handleCancel}/>);
};

export default SendEmailPage;
